import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './App.tsx'
import { CmsProvider } from './lib/cms'
import { entryFor } from './lib/routes'

// ponytail: entryFor() classifies the path — the app has exactly three entry points
const entry = entryFor(window.location.pathname)

const AdminApp = lazy(() => import('./admin/AdminApp').then((m) => ({ default: m.AdminApp })))
const WebinarsApp = lazy(() => import('./webinars/WebinarsApp').then((m) => ({ default: m.WebinarsApp })))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px' }}>Loading…</div>}>
      {entry === 'admin' ? (
        <AdminApp />
      ) : entry === 'webinars' ? (
        <WebinarsApp />
      ) : (
        <CmsProvider>
          <App />
        </CmsProvider>
      )}
    </Suspense>
  </StrictMode>,
)
